import { ApplicationPipesModule } from "./shared/pipes/application-pipes.module";
import { ImagesPDF } from "./shared/images/imagesPDF";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoginModule } from "./login/login.module";
import { MaterialModule } from "./material-module";
import { MenuModule } from "./menu/menu.module";
import { HomeComponent } from "./home/home.component";
import { NgxMaskModule, IConfig } from "ngx-mask";
import { DadosFormModule } from "./home/dados-form/dados-form.module";
import { PdfAprovacaoComponent } from "./home/pdf-aprovacao/pdf-aprovacao.component";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  declarations: [AppComponent, HomeComponent, PdfAprovacaoComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    LoginModule,
    MenuModule,
    DadosFormModule,
    LoadingBarRouterModule,
    NgxMaskModule.forRoot(options),
    ApplicationPipesModule,
  ],
  providers: [ImagesPDF],
  bootstrap: [AppComponent],
})
export class AppModule {}
